<template>
	<div>
		<div id="login-panel">
			<div class="row align-items-center splash-box-row no-lr-margins">
				<div class="col align-self-center">
					<div class="container">
						<div class="row no-lr-margins">
							<div class="col">
								<div class="container login-controls">
									<div class="row no-lr-margins">
										<div class="col align-self-center">
											<div class="card">
												<div class="container login-logos-container">
													<div class="row login-logos-row">
														<div class="login-logos-col text-center">
															<img src="../assets/cd-head-image.jpg" class="login-logo" style="height:110px;">
															<h1 class="login-title">Feis Music Online</h1>
														</div>
													</div>
												</div>
												<div class="card-body login-controls-container">
													<form id="loginForm" @submit="submit">
														<div>
															<div class="list-text">
																<p>
																	This website is completely free to use for the forseable future however if you do have a pound/euro/dollar spare, the Irish Cancer Society and St.Luke's Hospice would be delighted with any small donations. Please consider leaving a donation at:
																</p>
																<a href="https://www.justgiving.com/team/GerryConlonFeisMusic" target="_blank" rel="noopener noreferrer">Gerry Conlon's Just Giving Page</a> (Click 'Donate to a team member' and select one of the two charities.)
																<p></p>
															</div>
															<div class="donation-text">
																<a href="https://www.justgiving.com/team/GerryConlonFeisMusic" target="_blank" rel="noopener noreferrer">Gerry Conlon's Just Giving Page</a> (Click 'Donate to a team member' and select one of the two charities.)
																<p></p>
																<p>
																	Enjoy the music and Thank You all very much for your kind donations which will go directly to the charities.
																</p>
															</div>
															<div id="region-selector">
																<select class="speed-selector" ref="regionInputRef" @change="onChange($event)" aria-label="Select regional speeds">
																	<option value="" selected>Select regional speeds</option>
																	<option v-for="item in options.default" :key="item?.region" :value="item?.region" class="dropdown-item">{{item?.region}}</option>
																</select>
															</div>
														</div>
														
														<button type="submit" class="btn site-btn-primary login-button" :disabled="isDisabled">
															Continue
														</button>
													</form>
													<div class="row">
														<div class="support-msg all-text">
															<p><b>Disclaimer:</b> This is not an App and therefore requires either WiFi or a mobile signal to function efficiently. All music is <b>streamed</b> and will not be downloaded to your device.</p>
														</div>
													</div>
													<div class="row">
														<div class="support-msg all-text">
															<p><b>Enquiries:</b> support@feis.gerryconlon.com</p>
														</div>
													</div>
													<div class="row">
														<div class="copyright-msg all-text">
															<p>@Copyright 2021</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, ref, inject, onBeforeMount } from "vue";
// eslint-disable-next-line no-unused-vars
import IConfigurationService from "../interfaces/configuration_service";
// eslint-disable-next-line no-unused-vars
import IRegions, { IRegionFilters } from "@/interfaces/region_filters";

import router from "../router";

interface IRegionSelectorOption
{
	region: string
}

export default defineComponent({
	emits: ["authenticated"],
	setup()
	{
		const regionInputRef = ref<HTMLElementTagNameMap>();
		const configurationService = inject<IConfigurationService>("configurationService");
		
		const options = ref<IRegions>();
		const selectedOption = ref<IRegionSelectorOption>();
		const selectedRegion = ref<any>();
		
		const isDisabled = ref<boolean>(true);

		if (!configurationService)
		{
			throw new Error("Configuration service not initialised");
		}

		async function submit(evt:Event)
		{
			if (evt)
			{
				evt.preventDefault();
			}

			router.replace({ name: 'music' });
		}

		// Now getting the regions minus any online feis'
		function loadRegionFilters()
		{
			let regionFilters = configurationService?.getRegionFilters();
			if (regionFilters)
			{
				options.value = regionFilters;
			}
		}

		function onChange(event: any)
		{
			isDisabled.value = true;
			if (event.target.value)
			{
				// Just set the selected region so that we can use it later
				configurationService?.setSelectedRegion(event.target.value);

				selectedRegion.value = configurationService?.getSelectedRegion();
				isDisabled.value = false;
			}
		}
		
		onBeforeMount(function()
		{
			loadRegionFilters();
		});

		return {
			regionInputRef,
			submit,
			options,
			selectedOption,
			onChange,
			isDisabled
		};
	}
});
</script>

<style lang="scss" scoped>
@import "../styles/palette";
@import "../styles/layout";

.support-msg
{
	width: 100%;
	font-size: 10px;
	text-align: center;
	padding-left: 0;
	margin-left: 0;
	padding-top: 35px;
	padding-bottom: 0px;
}
.copyright-msg
{
	width: 100%;
	font-size: 10px;
	text-align: center;
	font-weight: bold;
	padding-right: 0;
	margin-right: 0;
	padding-top: 0px;
}

#region-selector
{
	display: flex;
	justify-content: left;
	align-items: flex-start;
	background-color: $actions-page-2;
}

.speed-selector
{
	display: block;
	width: 100%;
	height: calc(1.5em + 0.75rem + 2px);
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	align-items: center;
	border-color: $primary-purple-2;
	border-radius: 0.25rem;
	border: 1px solid #ced4da; 
	background-color: #fff;
	color: #495057;
	padding: .375rem .50rem;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;

}
.speed-selector:focus
{
	color: #495057;
	background-color: #fff;
	border-color: #6e96d5;
	outline: 0;
	box-shadow: 0 0 0 0.2rem rgb(44 86 151 / 25%);
}
.list-text, .donation-text {
	font-family: Apple Chancery, cursive;
	font-style: italic;
	//text-align: left;
	font-weight: normal;
	font-size: 12px;
	color: $primary-purple-2;
}
.donation-text {
	display: none;
}

.login-controls
{
	max-width: 500px !important;
	text-align: center;
}

.login-logo
{
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.login-logo, .login-logos-col 
{
	width: 100%;
}

.login-logos-container
{
	padding: 0px;
}

.login-logos-row
{
	margin: 0px;
}
.login-logos-col
{
	margin-left: 0px;
	padding-left: 0px;
	padding-bottom: 0px;
}

.login-controls-container
{
	background-color: $actions-page-2;
}

.login-text
{
	margin-bottom: 20px;
}

.login-input
{
	margin-bottom: 10px;
}
.login-title
{
	color: $primary-purple-2;
	font-size: 30px;
	font-family: Apple Chancery, cursive;
	font-weight: bold;
	font-style: italic;
	position: relative;
	top: -50px;
	height: 0;
	text-align: center;
}
.all-text {
	font-family: Apple Chancery, cursive;
	font-style: italic;
	text-align: center;
	color: $primary-purple-2;
}
.login-button
{
	margin-top: 25px;
	margin-bottom: 10px;
}

:not(output):-moz-ui-invalid:not(:focus) {
  box-shadow: none;
}

:not(output):-moz-ui-invalid:-moz-focusring:not(:focus) {
  box-shadow: none;
}
#login-panel
{
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
}

.site-btn-outline-primary:hover, 
.site-btn-outline-primary:focus, 
.site-btn-outline-primary:active, 
.site-btn-outline-primary.active, .open>.dropdown-toggle.site-btn-outline-primary {
    color: #fff;
    background-color: $primary-feis-red-1;
    border-color: $secondary-purple-2;
}
@media only screen and (max-width: 1920px) {
	.login-title
	{
		font-size: 26px;
	}
	.support-msg
	{
		font-size: 12px;
	}
	.copyright-msg
	{
		font-size: 8px;
	}
}

@media only screen and (max-width: 414px) {
	.login-title
	{
		font-size: 26px;
	}
	.support-msg
	{
		font-size: 10px;
	}
	.copyright-msg
	{
		font-size: 8px;
	}
	.list-text
	{
		display: none;
	}
}

@media only screen and (max-width: 375px) {
	.login-title
	{
		font-size: 24px;
	}
	.login-input
	{
		font-size: 12px;
	}
	.speed-selector
	{
		font-size: 12px;
	}
}

@media only screen and (max-width: 320px) {
	.login-title
	{
		font-size: 18px;
	}
	.login-input
	{
		font-size: 12px;
	}
	.speed-selector
	{
		font-size: 12px;
	}
}
@media only screen and (max-width: 280px) {
	.login-title
	{
		font-size: 18px;
	}
	.login-input
	{
		font-size: 12px;
	}
	.speed-selector
	{
		font-size: 12px;
	}
}
</style>
